<template>
  <div class="column">
    <div class="mrs mbm flex-container">
      <span class="text-left medium-6">
        Vous regardez {{ count }} projets.
      </span>
      <div class="text-right medium-6">
        <span class="mls">
          <a :disabled="!enabled" @click="removeAllCompleted">
            Supprimer tout terminé
          </a>
          <span> |</span>
          <a :disabled="!enabled" @click="clearFilters">
            Effacer les filtres
          </a>
        </span>
      </div>
    </div>
    <div class="flex-container align-middle mbm">
      <label for="filters">Filtres:</label>
      
      <select v-model="status" class="mbn mls mrs">
        <option
          v-for="(option, index) in briefOptions"
          :key="index"
          :value="option.value"
          :disabled="!enabled"
          class="mls mrs">
          {{ option.label }}
        </option>
      </select>
      
      <select v-model="daysLeft" class="mbn mls">
        <option
          v-for="(option, index) in dayOptions"
          :key="index"
          :value="option.value"
          :disabled="!enabled"
          class="mls mrs">
          {{ option.label }}
        </option>
      </select>
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      status: null,
      daysLeft: null,
      briefOptions: [
        {
          label: `Filtrer le statut bref`,
          value: null,
        },
        {
          label: `En cours`,
          isSelected: false,
          value: 'Open',
        },
        {
          label: `Décision`,
          value: 'Deciding',
        },
        {
          label: `terminés`,
          value: 'Closed',
        },
      ],
      dayOptions: [
        {
          label: `Filtrer par jour(s) restant`,
          value: null,
        },
        {
          label: `Moins d'1 jour`,
          value: '1',
        },
        {
          label: `Moins de 3 jours`,
          value: '3',
        },
        {
          label: `Moins de 7 jours`,
          value: '7',
        },
        {
          label: `Moins de 10 jours`,
          value: '10',
        },
        {
          label: `Moins de 15 jours`,
          value: '15',
        },
      ],
    };
  },
  watch: {
    async status(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
    async daysLeft(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
  },
  methods: {
    async update() {
      if (!this.enabled) {
        return;
      }
      this.$emit('filter-update', {
        status: this.status,
        daysLeft: this.daysLeft,
      });
    },
    removeAllCompleted() {
      this.$emit('remove-all-completed');
    },
    clearFilters() {
      this.status = null;
      this.daysLeft = null;
      this.update();
    },
  },
};
</script>
